import { combineReducers } from 'redux';

import {
  SELECT_PROPOSAL,
  UPDATED_PROPOSAL,
  FINISHED_PROPOSAL,
} from 'modules/affiliation/actions/affiliation.action';

const selectedProposal = (state = {}, action) => {
  switch (action.type) {
    case SELECT_PROPOSAL:
      return action.payload;
    case UPDATED_PROPOSAL:
      return action.payload;
    case FINISHED_PROPOSAL:
      return {};
    default:
      return state;
  }
};

export default combineReducers({
  selectedProposal,
});
